import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationFetchInfinityProjectArgs, BackendProject } from 'src/types/backend';

const MUTATION = gql`
  mutation FetchInfinityProject($workspaceId: ID!) {
    fetchInfinityProject(workspaceId: $workspaceId) {
      id
    }
  }
`;

type Variables = BackendMutationFetchInfinityProjectArgs;
type Result = Pick<BackendProject, 'id'>;

export const fetchInfinityProject = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
